import LazyLoad from 'vanilla-lazyload/dist/lazyload.js';
import initMap from './components/Map';
import FancyBox from './components/FancyBox';
import HeroSlider from './components/HeroSlider';
import MobileMenu from './components/MobileMenu';
import Header from './components/Header';
import Search from './components/Search';
import MenuDropdowns from './components/MenuDropdowns';
import MobileAccordion from './components/MobileAccordion';
import QuoteSlider from './components/QuoteSlider';
import MapSlider from './components/MapSlider';
import ResultSlider from './components/ResultSlider';
import ImageSlider from './components/ImageSlider';
import PropSlider from './components/PropSlider';
import SmoothScroll from './components/SmoothScroll';
import Tabs from './components/Tabs';
import TabSlider from './components/TabSlider';
import MoreLink from './components/MoreLink';
import Accordion from './components/Accordion';

new LazyLoad({
    elements_selector: ".lazy",
    threshold: 1000,
    skip_invisible: false
});

{
    //ImageLoader(loader);
    FancyBox();
}

{
    const navbar = document.querySelector('header');

    if (typeof navbar != 'undefined' && navbar) {
        MenuDropdowns();
    }
}

// Search
{
    let searchElement = document.querySelector('.search-trigger');
    if (typeof searchElement != "undefined" && searchElement != null) Search();
}

{
    let header = document.querySelector('header');
    if (typeof header != "undefined" && header != null) {
        Header();
    }
}

{
    let mobileMenuElement = document.querySelector('.mobile-menu');
    if (typeof mobileMenuElement != "undefined" && mobileMenuElement != null) {
        MobileMenu();
    }
}

{
    let hero = document.querySelector('.hero');
    if (typeof hero != "undefined" && hero != null) {
        HeroSlider();
    }
}

{
    let ACFmap = document.querySelector('.acf-map');

    if (typeof ACFmap != "undefined" && ACFmap != null) {
        initMap();
    }
}
// Style Gravity File Uploader.
{

    let uploadClass = '.ginput_container_fileupload';
    let uploaders = document.querySelectorAll(`${uploadClass}`);
    let label =  `<label class="uploadLabel">Choose File</label>`;

    if (typeof uploaders != "undefined" && uploaders != null) {
        Array.prototype.forEach.call(document.querySelectorAll(`${uploadClass}`), function (upload) {
            upload.insertAdjacentHTML("afterbegin", label);
            let uploadInput =  upload.children[2];
            uploadInput.addEventListener('change', (e) => {
                let fullPath = uploadInput.value;
                let startIndex = (fullPath.indexOf('\\') >= 0 ? fullPath.lastIndexOf('\\') : fullPath.lastIndexOf('/'));
                let filename = fullPath.substring(startIndex);
                if (filename.indexOf('\\') === 0 || filename.indexOf('/') === 0) {
                    filename = filename.substring(1);
                }
                if (filename.length >= 1) {
                    upload.children[0].innerHTML = filename;
                } else {
                    upload.children[0].innerHTML = 'Choose File';
                }
            })
        });
    }
}

{
    const footerElements = document.querySelector('.footer__heading--accordion');

    if (typeof footerElements != 'undefined' && footerElements) {
        MobileAccordion();
    }
}

{
    let gallerySliderElement = document.querySelector('.quote-slider__slider--active');
    if (typeof gallerySliderElement != "undefined" && gallerySliderElement != null) {
        QuoteSlider();
    }
}

{
    let mapSliderElement = document.querySelector('#mapslider');
    if (typeof mapSliderElement != "undefined" && mapSliderElement != null) {
        MapSlider();
    }
}

{
    let resultsTableElement = document.querySelector('#resultstable');
    if (typeof resultsTableElement != "undefined" && resultsTableElement != null) {
        ResultSlider();
    }
}

{
    let imageGallery = document.querySelector('#imageslider');
    if (typeof imageGallery != "undefined" && imageGallery != null) {
        ImageSlider();
    }
}

{
    let propGallery = document.querySelector('#propslider');
    if (typeof propGallery != "undefined" && propGallery != null) {
        PropSlider();
    }
}

{
    let anchorLink = document.querySelector('[data-smooth-scroll]');
    if (typeof anchorLink != "undefined" && anchorLink != null) {
        SmoothScroll(anchorLink);
    }
}

{
    let tabs = document.querySelector('[data-tabs]');
    if (typeof tabs != "undefined" && tabs != null) {
        Tabs();
    }
}

{
    let tab_slider = document.querySelector('[data-tab-slider]');
    if (typeof tab_slider != "undefined" && tab_slider != null) {
        TabSlider();
    }
}

{
    let more_expand = document.querySelector('[data-more]');
    if (typeof more_expand != "undefined" && more_expand != null) {
        MoreLink();
    }
}

{
    let accordions = document.querySelector('[data-question]');
    if (typeof accordions != "undefined" && accordions != null) {
        Accordion();
    }
}